import { createTransform } from "redux-persist";
import { Properties } from "../../models/polymer/Properties.model";
import { GenuinePolymerStates } from "../slices/genuine-polymer-slice";
import { AdministrativeRole, MyInfoWithDOD } from "../../models/polymer/MyInfo.model";

function classifyCurrentUser(currentUser: MyInfoWithDOD | AdministrativeRole | undefined) {
  if (currentUser === undefined) {
    return undefined;
  }

  const keys = Object.keys(currentUser);
  if (keys.includes("representee_uinfin")) {
    return new AdministrativeRole(currentUser);
  }

  return new MyInfoWithDOD(currentUser);
}

const GenuinePolymerTransform = createTransform(
  // transform state on its way to being serialized and persisted.
  (inboundState: GenuinePolymerStates, key) => {
    return inboundState;
  },
  // transform state being rehydrated
  (outboundState: GenuinePolymerStates, key) => {
    return {
      ...outboundState,
      properties: outboundState.properties.map((property) => {
        property.current_user = classifyCurrentUser(property.current_user)
        return new Properties(property);
      }),
    };
  },
  // define which reducers this transform gets called for.
  { whitelist: ["GenuinePolymerSlice"] }
);

export { GenuinePolymerTransform };
